import React, { useState, useEffect } from 'react'
import {
  Table,
  IconButton,
  Icon,
  Panel,
  ButtonGroup,
  Row,
  Col,
  Dropdown,
  SelectPicker,
  Input,
  DatePicker,
} from 'rsuite'
// import pathname from '../../constants/pathname'
// import { useHistory } from 'react-router-dom'
import { budgetFormat } from '../../utils/formatterUtil'
// import EditButton from '../../components/buttons/editButton/EditButton'
import ConfirmWidget from '../confirm/ConfirmWidget'
import TooltipButton from '../../components/buttons/TooltipButton'
import pathname from '../../constants/pathname'
import { doneLoading, startLoading } from '../../utils/loading'
import notification from '../../utils/notification'
import { downloadFile } from '../../utils/fileUtil'
import SearchButton from '../../components/buttons/searchButton/SearchButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import DatePickerCustom from '../../components/datePicker/DatePickerCustom'
import moment from 'moment'
import { getValueFromOptions } from '../../utils/dataUtil'
import { downloadEfillingFileByPath } from '../../redux/actions/eFilling'

export default function FillingListReportTable({
  schema,
  data,
  loading,
  onDelete,
  onSelect,
  isViewMode,
  onSelectToView,
  onSearch,
  onCancel,
  onClick = () => {},
  onExport,
  projectCode: _projectCode,
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [deleteObj, setDeleteObj] = useState({})
  const [pathFile, setPathFile] = useState([])
  const [handleOnExport, setHandleOnExport] = useState()
  const [txtSubmisStatusVal, setTxtSubmisStatusVal] = useState(0)
  const [submitStartDate, setSubmitStartDate] = useState()
  const [submitEndDate, setSubmitEndDate] = useState()
  const [taxMonthVal, settaxMonthVal] = useState()
  const [projectCodeVal, setProjectCodeVal] = useState()
  const [isError, setIsError] = useState(false)
  const [txtModelTypeVal, setTxtModelTypeVal] = useState(0)

  useEffect(() => {
    if(_projectCode){
      setProjectCodeVal(_projectCode)
    }
  }, [_projectCode])

  const handleSearch = () => {
    onSearch(
      txtSubmisStatusVal,
      submitStartDate,
      submitEndDate,
      taxMonthVal,
      projectCodeVal,
      txtModelTypeVal
    )
  }
  const onExportExcel = () => {
    onExport(
      txtSubmisStatusVal,
      submitStartDate,
      submitEndDate,
      taxMonthVal,
      projectCodeVal,
      txtModelTypeVal
    )
  }

  const handleCancel = () => {
    setTxtSubmisStatusVal(0)
    setTxtModelTypeVal(0)
    setSubmitStartDate('')
    setSubmitEndDate('')
    settaxMonthVal('')
    setProjectCodeVal('')
    onCancel()
  }

  const onDownload = (path) => {
    // console.log('onDownload==>', path)
    callGetDownloadService(path, 'download')
  }
  const onPreview = (path) => {
    // console.log('onPreview==>', path)
    callGetDownloadService(path, 'preview')
  }

  const callGetDownloadService = async (path, type) => {
    startLoading()

    try {
      // console.log('callGetDownloadService==>', path)
      let file = await downloadEfillingFileByPath(path)

      const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
      const link = document.createElement('a')
      link.href = url
      if (type == 'download') {
        link.setAttribute('download', path)
      } else {
        link.target = '_blank'
        link.setAttribute('value', path)
      }

      document.body.appendChild(link)
      setIsError()
      link.click()
    } catch (e) {
      if (type == 'download') {
        setIsError('ดาวน์โหลดล้มเหลว ' + e?.response?.status + ' ' + e?.response?.statusText)
      } else {
        setIsError('แสดงล้มเหลว ' + e?.response?.status + ' ' + e?.response?.statusText)
      }
    }
    doneLoading()
  }
  // console.log('data==>', data)
  return (
    <>
      <Panel bordered header={'ค้นหา'} collapsible defaultExpanded>
        <div style={{ marginTop: -10, marginBottom: -10 }}>
          <Row style={{ marginBottom: 10 }}>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              {schema.forms.projectCode.label}
              <Input
                value={projectCodeVal}
                onChange={(value) => {
                  setProjectCodeVal(value)
                }}
              />
            </Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              {schema.forms.submisStatus.label}
              <SelectPicker
                searchable={false}
                value={txtSubmisStatusVal}
                data={schema.forms.submisStatus.options}
                block
                onChange={(value) => {
                  setTxtSubmisStatusVal(value)
                }}
              />
            </Col>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
          </Row>
          <Row style={{ marginBottom: 10 }}>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              {schema.forms.submitStartDate.label}
              <DatePickerCustom
                {...props}
                placement="auto"
                value={submitStartDate}
                onChange={(value) => {
                  setSubmitStartDate(value)
                }}
                disabledDate={(date) =>
                  submitEndDate && moment(submitEndDate).isBefore(date, new Date())
                }
              />
            </Col>

            <Col lg={8} md={8} sm={24} xs={24}>
              {schema.forms.submiyEndDate.label}
              <DatePickerCustom
                {...props}
                placement="auto"
                value={submitEndDate}
                onChange={(value) => {
                  setSubmitEndDate(value)
                }}
                disabledDate={(date) =>
                  submitStartDate && moment(submitStartDate).isAfter(date, new Date())
                }
              />
            </Col>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
          </Row>
          <Row style={{ marginBottom: 10 }}>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              {schema.forms.taxMonth.label}
              {/* <DatePickerCustom
                {...props}
                placement="auto"
                value={taxMonthVal}
                onChange={(value) => {
                  settaxMonthVal(value)
                }}
              /> */}
              <DatePicker
                value={taxMonthVal}
                block
                format="MM/YYYY"
                ranges={[]}
                onOk={(e) => {
                  console.log(e)
                }}
                onChange={(value) => {
                  settaxMonthVal(value)
                }}
              />
            </Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              {schema.forms.modelType.label}
              <SelectPicker
                searchable={false}
                value={txtModelTypeVal}
                data={schema.forms.modelType.options}
                block
                onChange={(value) => {
                  setTxtModelTypeVal(value)
                }}
              />
            </Col>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
          </Row>

          <Row style={{ marginBottom: 10 }}>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              <SearchButton disabled={false} onClick={handleSearch}>
                ค้นหา
              </SearchButton>
              <CancelButton disabled={false} onClick={handleCancel}>
                ยกเลิก
              </CancelButton>
            </Col>
          </Row>
        </div>
      </Panel>
      <Row style={{ marginTop: 10 }}>
        <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
          <IconButton
            appearance="ghost"
            icon={<Icon icon="file-pdf-o" className="bt-gost-icon-radius" />}
            onClick={onExportExcel}
          >
            Export to Excel
          </IconButton>
        </Col>
      </Row>
      <Table wordWrap autoHeight loading={loading} data={data || []} style={{ marginTop: 10 }}>
        <Column width={70} align="center">
          <HeaderCell>ลำดับ</HeaderCell>
          <Cell>
            {(_, index) => {
              return index + 1
            }}
          </Cell>
        </Column>

        <Column width={150}>
          <HeaderCell>รหัสโครงการ</HeaderCell>
          <Cell dataKey="projectCode" />
        </Column>

        <Column width={150}>
          <HeaderCell>เลขที่ข้อตกลง</HeaderCell>
          <Cell dataKey="contractNo" />
        </Column>

        <Column width={150}>
          <HeaderCell>วัน/เดือน/ปี ที่ยื่นแบบ</HeaderCell>
          <Cell dataKey="submisDate" />
        </Column>

        <Column width={100}>
          <HeaderCell>ประเภทแบบ</HeaderCell>
          <Cell dataKey="modelType" />
        </Column>

        <Column width={120}>
          <HeaderCell>เดือน/ปี(ภาษี)</HeaderCell>
          <Cell dataKey="taxMonth" />
        </Column>

        <Column width={180} align={'center'}>
          <HeaderCell>ลำดับการยื่นแบบ</HeaderCell>
          <Cell dataKey="submisList" />
        </Column>

        <Column width={350} align={'center'}>
          <HeaderCell>หมายเลขอ้างอิงรอชำระเงิน/หมายเลขอ้างอิงการยื่นแบบ</HeaderCell>
          <Cell dataKey="taxReferCode" />
        </Column>

        <Column width={250} align={'center'}>
          <HeaderCell>สถานะผลการยื่นแบบ</HeaderCell>
          {/* <Cell dataKey="submisStatus" /> */}
          <Cell>
            {(rowData) => {
              // console.log(rowData.submisType)
              // console.log(schema)
              return getValueFromOptions(schema.forms.submisStatus.options, rowData.submisStatus)
            }}
          </Cell>
        </Column>

        <Column width={120} >
          <HeaderCell>จำนวนเงิน</HeaderCell>
          <Cell style={{ textAlign: 'right' }}>
            {(rowData) => {
              return budgetFormat(rowData.taxAmount1)
            }}
          </Cell>
        </Column>

        <Column width={150} align={'center'}>
          <HeaderCell>วันที่ใบเสร็จรับเงิน</HeaderCell>
          <Cell dataKey="receiptDate" />
        </Column>
        <Column width={200} align={'center'}>
          <HeaderCell>ชื่อผู้ยื่นแบบ</HeaderCell>
          <Cell dataKey="submitName" />
        </Column>
        <Column width={150} align={'center'}>
          <HeaderCell>เบอร์โทรติดต่อ</HeaderCell>
          <Cell dataKey="submitContrctPhoneNo" />
        </Column>

        <Column width={200} align={'center'}>
          <HeaderCell>วันที่ทำรายการ</HeaderCell>
          <Cell dataKey="receiptDate" />
        </Column>

        <Column width={200} align={'center'}>
          <HeaderCell>วันที่แก้ไขรายการล่าสุด</HeaderCell>
          <Cell dataKey="updateDate" />
        </Column>

        <Column width={130} align="center" fixed="right">
          <HeaderCell>ใบเสร็จรับเงิน</HeaderCell>
          <Cell>
            {(rowData) => {
              if (!rowData.withholdingTaxFormPath) {
                return
              }
              return (
                <>
                  <ButtonGroup>
                    <TooltipButton
                      isStart={true}
                      icon="eye"
                      tooltip={`แสดง`}
                      onClick={(e) => onPreview(rowData.billFilePath)}
                      // disabled={!rowData.billFilePath}
                    />
                    <TooltipButton
                      isStart={false}
                      icon="download"
                      tooltip={`ดาวน์โหลด`}
                      onClick={(e) => onDownload(rowData.billFilePath)}
                      // disabled={!rowData.billFilePath}
                    />
                  </ButtonGroup>
                </>
              )
            }}
          </Cell>
        </Column>
        <Column width={130} align="center" fixed="right">
          <HeaderCell>แบบยื่น ภงด.</HeaderCell>
          <Cell>
            {(rowData) => {
              if (!rowData.withholdingTaxFormPath) {
                return
              }
              return (
                <>
                  <ButtonGroup>
                    <TooltipButton
                      isStart={true}
                      icon="eye"
                      tooltip={`แสดง`}
                      onClick={(e) => onPreview(rowData.withholdingTaxFormPath)}
                      // disabled={!rowData.withholdingTaxFormPath}
                    />
                    <TooltipButton
                      isStart={false}
                      icon="download"
                      tooltip={`ดาวน์โหลด`}
                      onClick={(e) => onDownload(rowData.withholdingTaxFormPath)}
                      // disabled={!rowData.withholdingTaxFormPath}
                    />
                  </ButtonGroup>
                </>
              )
            }}
          </Cell>
        </Column>
      </Table>

      <ConfirmWidget
        title={`ยืนยันการลบรายการ`}
        show={isShowConfirm}
        detail={`ยืนยันการลบ`}
        onCancle={() => {
          setIsShowConfirm(false)
          setDeleteObj({})
        }}
        onConfirm={() => {
          onDelete(deleteObj)
          setIsShowConfirm(false)
        }}
      />
    </>
  )
}
